/**
 * @generated SignedSource<<353cc01fece1c8881e03e1decf5cbc73>>
 * @relayHash 8fecacabe46771ea2cc96b3cc62f9c72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
